import { Button, makeStyles, mergeClasses } from "@fluentui/react-components";
import { $sky60 } from "../../../cssjs/colors";

export interface IDateTimeFilterActionsProps {
  onResetHandler: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  onCancelHandler: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  onApplyHandler: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  diableApplyButton?: boolean;
}

export default function DateTimeFilterActions({
  diableApplyButton = false,
  ...props
}: IDateTimeFilterActionsProps) {
  const classes = useStyles();

  return (
    <footer className="pt-sm-4 amd-container-vcenter jc-spacebtwn">
      <Button
        className={mergeClasses(classes.button, classes.resetButton, "mr-1")}
        onClick={props.onResetHandler}
        size="small"
      >
        Reset
      </Button>
      <div>
        <Button
          onClick={props.onCancelHandler}
          size="small"
          className={mergeClasses(classes.button, "mr-1")}
        >
          Cancel
        </Button>
        <Button
          appearance="primary"
          onClick={props.onApplyHandler}
          size="small"
          className={mergeClasses(classes.button, classes.applyButton, "fs-18")}
          disabled={diableApplyButton}
        >
          Apply filter
        </Button>
      </div>
    </footer>
  );
}

const useStyles = makeStyles({
  button: {
    padding: "10px",
    fontSize: "14px",
    fontWeight: 500,
  },
  resetButton: {
    color: "#0C66E1",
    border: `1px solid ${$sky60}`,
    "&:hover": {
      border: `1px solid ${$sky60}`,
    },
  },
  applyButton: {
    backgroundColor: $sky60,
    marginLeft: "10px",
    "&:disabled": {
      border: `1px solid ${$sky60} !important`,
    },
  },
});
